const buyerEn = {
  BUYER_PORTAL_TITLE_LEGACY: 'Buyer Portal',
  TOPBAR_AVATAR_TOOLTIP: '{{name}} · profile',
  SIGN_IN_SUBTITLE: 'Sign in to view your orders and continue shopping.',
  FORGOT_PASSWORD: 'Forgot password?',
  FORGOT_PASSWORD_TITLE: 'Reset your password',
  FORGOT_PASSWORD_DESC:
    "Enter the email tied to your account and we'll send you a link to reset your password.",
  SEND_RESET_LINK: 'Send reset link',
  FORGOT_PASSWORD_SENT:
    "Sent! Check your inbox for the password reset link.",
  FORGOT_PASSWORD_FAILED: 'Could not send the email. Please try again later.',
  RESET_PASSWORD_TITLE: 'Reset your password',
  RESET_PASSWORD_DESC: 'Choose a new password for your account.',
  RESET_PASSWORD_SUBMIT: 'Reset password',
  RESET_PASSWORD_SUCCESS: 'Password updated. You can now sign in with your new password.',
  RESET_PASSWORD_FAILED: 'Could not reset the password. The link may have expired.',
  RESET_PASSWORD_MISSING_TOKEN: 'This reset link is invalid or expired. Please request a new one.',
  BACK_TO_LOGIN: 'Back to sign in',
  NEW_PASSWORD: 'New password',
  CONFIRM_PASSWORD: 'Confirm password',
  PLEASE_ENTER_NEW_PASSWORD: 'Enter your new password',
  PLEASE_CONFIRM_PASSWORD: 'Re-enter your new password',
  PASSWORDS_DO_NOT_MATCH: "Passwords don't match",
  SUBMITTING: 'Submitting…',
  PAGE_TITLE_RESET_PASSWORD: 'Reset password',
  CHANGE_PASSWORD: 'Change password',
  CURRENT_PASSWORD: 'Current password',
  CHANGE_PASSWORD_SUCCESS: 'Password changed.',
  CHANGE_PASSWORD_WRONG_CURRENT: 'Current password is incorrect.',
  CHANGE_PASSWORD_FAILED: 'Could not change the password.',
  EMAIL: 'Email',
  PLEASE_ENTER_EMAIL: 'Please enter your email',
  SIGNING_IN: 'Signing in…',
  SIGN_OUT: 'Sign out',
  LOGIN_SUCCESS: 'Signed in successfully',
  LOGIN_FAILED: 'Sign in failed',
  LOGIN_BRAND_EYEBROW: 'Trusted by 480+ businesses',
  LOGIN_BRAND_TAGLINE: 'Medical supplies, ordered with confidence.',
  LOGIN_BRAND_BLURB:
    'Live warehouse stock. No preorders. No oversells. Pay only for what we have on the shelf today.',
  LOGIN_WELCOME_BACK: 'Welcome back',
  KEEP_SIGNED_IN: 'Keep me signed in on this device',
  OR: 'OR',
  NEW_TO_VMALL: 'New to VMall?',
  REGISTER_YOUR_CLINIC: 'Register',
  OR_BROWSE_AS_GUEST: 'Or',

  REGISTER_PAGE_TITLE: 'Create your account',
  REGISTER_PAGE_SUBTITLE: 'Three quick steps. Save and continue any time.',
  REGISTER_IDENTITY_TITLE: 'Account type',
  REGISTER_IDENTITY_INDIVIDUAL: 'Individual',
  REGISTER_IDENTITY_INDIVIDUAL_DESC: 'For personal use. You can join a Business later if invited.',
  REGISTER_IDENTITY_BUSINESS: 'Business',
  REGISTER_IDENTITY_BUSINESS_DESC: 'For practices, clinics, and teams. Invoices billed to the business; you can invite teammates.',
  REGISTER_SUBTITLE_INDIVIDUAL: 'Create a personal VMall account.',
  REGISTER_SUBTITLE_BUSINESS: 'Register a Business and become its Owner.',
  REGISTER_ALREADY_HAVE_ACCOUNT: 'Already have an account?',
  REGISTER_SIGN_IN: 'Sign in',
  REGISTER_STEP_1: 'Business identity',
  REGISTER_STEP_2: 'Primary contact',
  REGISTER_STEP_3: 'Address & review',
  REGISTER_STEP_LABEL: 'STEP {{n}}',
  REGISTER_BACK: 'Back',
  REGISTER_CONTINUE: 'Continue',
  REGISTER_SAVE_LATER: 'Save & continue later',
  REGISTER_SUBMIT: 'Submit registration',
  REGISTER_SUBMITTING: 'Submitting…',

  REGISTER_S1_HEADING: 'Business identity',
  REGISTER_S1_SUBHEADING: 'Tell us about your business. We use this for compliance and invoicing.',
  REGISTER_TRADING_NAME: 'Trading name',
  REGISTER_LEGAL_ENTITY: 'Legal entity',
  REGISTER_ABN: 'ABN',
  REGISTER_ABN_HELP: '11-digit Australian Business Number',
  REGISTER_CLINIC_TYPE: 'Business type',
  REGISTER_AHPRA: 'AHPRA registration #',
  REGISTER_TYPE_GP: 'GP / Family practice',
  REGISTER_TYPE_SPECIALIST: 'Specialist practice',
  REGISTER_TYPE_DENTAL: 'Dental practice',
  REGISTER_TYPE_ALLIED: 'Allied Health',
  REGISTER_TYPE_OTHER: 'Other',

  REGISTER_S2_HEADING: 'Primary contact & login',
  REGISTER_S2_SUBHEADING: 'Who manages ordering for this business?',
  REGISTER_FIRST_NAME: 'First name',
  REGISTER_LAST_NAME: 'Last name',
  REGISTER_ROLE: 'Role',
  REGISTER_PHONE: 'Phone',
  REGISTER_WORK_EMAIL: 'Work email',
  REGISTER_CONFIRM_EMAIL: 'Confirm email',
  REGISTER_PASSWORD: 'Password',
  REGISTER_CONFIRM_PASSWORD: 'Confirm password',
  REGISTER_PASSWORD_HELP: 'At least 12 characters · 1 uppercase · 1 number',
  REGISTER_PASSWORD_MISMATCH: "Passwords don't match",
  REGISTER_EMAIL_MISMATCH: "Emails don't match",
  REGISTER_OWNER_NOTE:
    'This will be the Owner account. You can invite Purchasers, Members & Viewers later from Settings → Users.',

  REGISTER_S3_HEADING: 'Address & review',
  REGISTER_S3_SUBHEADING: 'Where should we deliver and bill? You can add more addresses later.',
  REGISTER_ADDRESS_LINE_1: 'Address line 1',
  REGISTER_ADDRESS_LINE_2: 'Address line 2 (optional)',
  REGISTER_CITY: 'Suburb / City',
  REGISTER_STATE: 'State',
  REGISTER_POSTCODE: 'Postcode',
  REGISTER_REVIEW_HEADING: 'Review',
  REGISTER_TERMS_AGREE:
    'I agree to VMall’s Terms of Service and confirm I have authority to register on behalf of this business.',

  REGISTER_SIDE_WHY_TITLE: 'WHY WE ASK',
  REGISTER_SIDE_WHY_S1:
    'ABN and AHPRA verify you are a registered Australian healthcare practice. We never share these with suppliers.',
  REGISTER_SIDE_WHY_S2:
    'The Owner is the legal contact for orders, invoices & account decisions. Phone is used for delivery confirmation only — never marketing.',
  REGISTER_SIDE_WHY_S3:
    'A default shipping & billing address lets you order on day one. You can add branches and storage sites later.',
  REGISTER_SIDE_SUMMARY_S1: 'Step 1 summary',
  REGISTER_SIDE_SUMMARY_S2: 'Step 2 summary',
  REGISTER_NEED_HELP: 'Need help registering?',
  REGISTER_TALK_TO_ONBOARDING: 'Talk to onboarding →',

  REGISTER_BUSINESS_NAME: 'Business name',
  REGISTER_FULL_NAME: 'Full name',
  REGISTER_PHONE_OPTIONAL: 'Phone (optional)',
  REGISTER_PASSWORD_MIN_8: 'At least 8 characters',
  REGISTER_EMAIL_FROM_INVITATION: 'Pre-filled from your invitation',
  REGISTER_PASSWORD_TOO_SHORT: 'Password must be at least 8 characters',
  REGISTER_DEFAULT_ADDRESS_OPTIONAL: 'Default address (optional)',
  REGISTER_REQUIRED_FIELD: 'This field is required',
  REGISTER_INVALID_EMAIL: 'Please enter a valid email',
  REGISTER_INVALID_ABN: 'ABN must be 11 digits',
  REGISTER_PASSWORD_TOO_WEAK: 'Use 12+ characters with an uppercase letter and a number',
  REGISTER_SUCCESS: 'Registration submitted. We will review your application shortly.',
  REGISTER_FAILED: 'Registration failed. Please try again.',

  ACCOUNT_INACTIVE_TITLE: 'Your account is not active',
  ACCOUNT_INACTIVE_DESC:
    'This account is currently disabled or pending review. Please contact platform support.',

  FORBIDDEN_TITLE: 'Access denied',
  FORBIDDEN_DESC: 'You do not have permission to access this portal.',
  GO_TO_LOGIN: 'Go to sign in',

  ERROR_OCCURRED: 'Something went wrong',
  RETRY: 'Retry',

  PRODUCT_LIST_TITLE: 'Product List',
  PRODUCT_DETAILS_TITLE: 'Product details',
  SEARCH_HERB_NAME: 'Search products',
  FILTER_BY: 'Filter by',
  FILTER_BY_COUNT: 'Filter by {{count}}',
  FILTER_RESET: 'Reset',
  HERB_ORIGIN_TYPE: 'Herb origin/type',
  HERB_ORIGIN_ALL: 'All',
  HERB_ORIGIN_ROOT_RHIZOME: 'Root & rhizome',
  HERB_ORIGIN_LEAVES_FLOWERS: 'Leaves & flowers',
  HERB_ORIGIN_FRUITS_SEEDS: 'Fruits & seeds',
  HERB_ORIGIN_BARK_RESIN: 'Bark & resin',
  HERB_ORIGIN_ANIMAL: 'Animal',
  HERB_ORIGIN_MINERAL: 'Mineral',
  HERB_ORIGIN_WHOLE_HERB: 'Whole herb',
  TAG_SPECIAL: 'Special',
  TAG_FREQUENT: 'Frequent',
  PRODUCT_INFO: 'Product Info',
  INFO_SECTION_GENERAL: 'General Information',
  INFO_SECTION_INGREDIENTS: 'Ingredients',
  INFO_SECTION_DIRECTIONS: 'Directions',
  INFO_SECTION_WARNINGS: 'Warnings',
  PRODUCT_USE_DISCLAIMER:
    'Always read the label and follow the directions for use. Incorrect use could be harmful. Please refer to your health and product warnings below.',
  ADD: 'Add',
  CART: 'Cart',
  PRODUCT_ID_LABEL: 'ID',

  PRODUCTS_TITLE: 'Products',
  PRODUCTS_DESC: 'Browse approved warehouse stock.',
  PRODUCTS_EMPTY_TITLE: 'No products available',
  PRODUCTS_EMPTY_DESC: 'Try a different keyword or clear the filters.',
  PRODUCT_NO_IMAGE: 'No image',
  PRODUCTS_CATEGORIES_HEADING: 'CATEGORIES',
  PRODUCTS_CATEGORY_ALL: 'Show all',
  PRODUCTS_CATEGORY_HERBS: 'Chinese herbs',
  PRODUCTS_CATEGORY_MEDICINE: 'Medicines',
  PRODUCTS_CATEGORY_SUPPLIES: 'Medical supplies',
  PRODUCTS_CATEGORY_CONSUMABLE: 'Consumables',
  PRODUCTS_CATEGORY_EQUIPMENT: 'Equipment',
  PRODUCTS_CATEGORY_OTHER: 'Other',
  PRODUCTS_CATEGORY_PHYSICAL: 'Products',
  PRODUCTS_CATEGORY_VIRTUAL: 'Training courses',
  PRODUCTS_FILTERS_TITLE: 'Filters',
  PRODUCTS_FILTERS_RESET: 'Reset',
  PRODUCTS_FILTERS_GROUP_QUICK: 'QUICK FILTERS',
  PRODUCTS_FILTERS_GROUP_BRAND: 'BRAND',
  PRODUCTS_FILTERS_GROUP_PRICE: 'PRICE RANGE',
  PRODUCTS_FILTER_IN_STOCK: 'In stock only',
  PRODUCTS_FILTER_PREVIOUSLY_ORDERED: 'Previously ordered',
  PRODUCTS_FILTER_ON_PROMOTION: 'On promotion',
  PRODUCTS_FILTERS_BUTTON: 'Filters',
  PRODUCTS_RESULTS_COUNT: '{{count}} results · sort by',
  PRODUCTS_SORT_MOST_ORDERED: 'Most ordered',
  PRODUCTS_SORT_NEWEST: 'Newest',
  PRODUCTS_SORT_PRICE_ASC: 'Price ↑',
  PRODUCTS_SORT_PRICE_DESC: 'Price ↓',
  PRODUCTS_PAGINATION_ROWS_PER_PAGE: 'Per page:',
  PRODUCTS_PAGINATION_DISPLAYED: '{{from}}–{{to}} of {{count}}',
  PRODUCTS_ACTIVE_FILTERS_LABEL: 'Active:',
  PRODUCTS_CLEAR_ALL: 'Clear all',
  PRODUCT_TAB_SPECS: 'Specifications',
  PRODUCT_TAB_COMPLIANCE: 'Compliance & docs',
  PRODUCT_TAB_ORDER_HISTORY: 'Your order history',
  PRODUCT_TAB_SUBSTITUTES: 'Substitutes',
  PRODUCT_DOC_DOWNLOAD: 'Download ↓',
  PRODUCT_HISTORY_LEAD: 'You ordered this <0>{{count}} times</0> in the last 6 months',
  PRODUCT_NO_SUBSTITUTES: 'No substitute products available right now.',
  PRODUCT_BREADCRUMB_CATALOGUE: 'Catalogue',
  PRODUCT_TGA_REGISTERED: 'TGA registered',
  PRODUCT_PRICE_PER_UNIT: '/unit',
  PRODUCT_PRICE_PLUS_GST: '+ GST {{amount}}',
  PRODUCT_QUANTITY_LABEL: 'QUANTITY',
  PRODUCT_QUANTITY_RANGE: 'MOQ {{moq}} · max {{max}}',
  PRODUCT_QUANTITY_RANGE_UNLIMITED: 'MOQ {{moq}} · unlimited',
  PRODUCT_ADD_TO_CART_AMOUNT: '+ Add to cart · {{amount}}',
  PRODUCT_ADD_TO_CART: 'Add to cart',
  PRODUCT_TOTAL_LABEL: 'Total',
  PRODUCT_SUPPLIED_BY: 'Supplied by',
  PRODUCT_NO_SPECS: 'No specifications provided.',
  PRODUCT_SPEC_CATEGORY: 'Category',
  PRODUCT_SPEC_TYPE: 'Product type',
  PRODUCT_SPEC_SKU: 'SKU',
  PRODUCT_SPEC_SPECIFICATION: 'Specification',
  PRODUCT_SPEC_UNIT: 'Unit',
  SQUARE_LOADING: 'Loading secure card form…',
  SQUARE_LOAD_FAILED: 'Could not load the secure card form. Please retry.',
  SQUARE_NOT_READY: 'Card form is not ready yet.',
  SQUARE_TOKENIZE_FAILED: 'Card validation failed. Please check the details.',
  SQUARE_TEST_HINT: 'Sandbox test card: 4111 1111 1111 1111 · any future date · any CVV.',
  ORDER_PAY_TITLE: 'Complete payment',
  ORDER_PAY_FAILED: 'Payment failed. Please try again or use a different card.',
  ORDER_PAID_BY_CARD: 'Paid by card',
  ORDER_NOT_PAID_YET: 'Awaiting payment',
  ORDER_INVOICE_DOWNLOAD_FAILED: 'Invoice download failed. Please retry.',
  PRODUCT_NO_DOCS: 'No documents available.',
  PRODUCT_HISTORY_LEAD_AUTHED: 'You ordered this {{count}} times in the last 6 months',
  SEARCH_PRODUCTS: 'Search products',
  CATEGORY_ALL: 'All categories',
  STOCK_ALL: 'All stock',
  CATEGORY_MEDICINE: 'Medicine',
  CATEGORY_CHINESE_HERB: 'Chinese herb',
  CATEGORY_MEDICAL_SUPPLY: 'Medical supply',
  CATEGORY_CONSUMABLE: 'Consumable',
  CATEGORY_EQUIPMENT: 'Equipment',
  CATEGORY_OTHER: 'Other',
  STOCK_IN_STOCK: 'In stock',
  STOCK_LOW_STOCK: 'Low stock',
  STOCK_OUT_OF_STOCK: 'Out of stock',
  PRODUCT_ONLY_N_LEFT: 'Only {{count}} left',
  PRODUCT_LAST_ORDERED_AGO: 'last ord {{days}}d ago',
  PRODUCT_TYPE: 'Type',
  PRODUCT_TYPE_ALL: 'All types',
  PRODUCT_TYPE_PHYSICAL: 'Product',
  PRODUCT_TYPE_VIRTUAL: 'Training course',
  VIRTUAL_FORMAT_ONLINE_COURSE: 'Online course',
  VIRTUAL_FORMAT_OFFLINE_COURSE: 'Offline workshop',
  VIRTUAL_FORMAT_OTHER: 'Other course',
  VIRTUAL_SLOTS_UNIT: 'seats',
  VIRTUAL_SLOTS_AVAILABLE: '{{count}} seats',
  VIRTUAL_SLOTS_LEFT: 'Only {{count}} seats left',
  VIRTUAL_SOLD_OUT: 'Sold out',
  VIRTUAL_DELIST_IN_DAYS_one: 'Closes in {{count}} day',
  VIRTUAL_DELIST_IN_DAYS_other: 'Closes in {{count}} days',
  VIRTUAL_DELISTED: 'Delisted',
  VIRTUAL_OPEN_ENROLMENT: 'Open enrolment',
  VIRTUAL_CAPACITY_LINE: '{{sold}} of {{capacity}} sold · {{remaining}} left',
  VIRTUAL_UNLIMITED_SLOTS: 'Unlimited seats',
  VIRTUAL_CAPACITY_LINE_UNLIMITED: '{{sold}} sold · unlimited capacity',
  PHYSICAL_STOCK_LINE: '{{moq}} · {{count}} in stock',
  PRICE_MIN_ORDER_SUFFIX: '(Min order: {{count}} {{unit}})',
  MOQ_LABEL: 'Min order {{count}}',
  UNITS_COUNT: '{{count}} units',
  ADDRESS_COUNTRY_FIXED: 'Phase 1 ships within Australia only.',
  PRODUCTS_FILTER_BRAND_CHIP: 'Brand · {{brand}}',
  PRODUCTS_FILTER_PRICE_CHIP: '${{min}}–${{max}}',
  PRODUCTS_FILTER_PRICE_MIN: 'Min',
  PRODUCTS_FILTER_PRICE_MAX: 'Max',
  PAGE_TITLE_DASHBOARD: 'Shopping history',
  PAGE_TITLE_CART: 'Cart',
  PAGE_TITLE_LOGIN: 'Sign in',
  PAGE_TITLE_REGISTER: 'Register',
  PAGE_TITLE_CHECKOUT: 'Checkout',
  PAGE_TITLE_404: 'Page not found',
  PAGE_TITLE_FORBIDDEN: 'Access denied',
  PAGE_TITLE_ACCOUNT_INACTIVE: 'Account inactive',
  PAGE_TITLE_NOTIFICATIONS: 'Notifications',
  PAGE_TITLE_PRODUCTS: 'Catalogue',
  PAGE_TITLE_PRODUCT_DETAIL: 'Product detail',
  PAGE_TITLE_SUPPLIERS: 'Suppliers',
  PAGE_TITLE_SUPPLIER_DETAIL: 'Supplier',
  PAGE_TITLE_ORDERS: 'Orders',
  PAGE_TITLE_ORDER_DETAIL: 'Order detail',
  PAGE_TITLE_TRACK_ORDER: 'Track order',
  PAGE_TITLE_PAYMENTS: 'Payments',
  PAGE_TITLE_PAYMENT_DETAIL: 'Payment detail',
  PAGE_TITLE_PROFILE: 'Profile',
  PAGE_TITLE_ADDRESSES: 'Addresses',
  PAGE_TITLE_BUSINESS_PROFILE: 'Business profile',
  PAGE_TITLE_MEMBERS: 'Members',
  PAGE_TITLE_INVITATIONS: 'Invitations',
  PAGE_TITLE_ONBOARDING: 'Welcome',
  PAGE_TITLE_ACCEPT_INVITATION: 'Accept invitation',
  SIGN_IN_TO_BUY: 'Sign in to buy',
  SUPPLIERS_TITLE: 'Suppliers',
  SUPPLIERS_SUBTITLE: 'Brands that ship through VMall.',
  SUPPLIERS_EMPTY: 'No public suppliers yet.',
  SUPPLIERS_HEADER_TITLE: 'Browse suppliers',
  SUPPLIERS_HEADER_LEAD: 'All inventory ships from VMall consigned warehouses.',
  SUPPLIERS_VERIFIED_BADGE_one: '{{count}} verified supplier',
  SUPPLIERS_VERIFIED_BADGE_other: '{{count}} verified suppliers',
  SUPPLIERS_TGA_BADGE: 'All TGA-listed',
  SUPPLIERS_SEARCH_PLACEHOLDER: 'Search suppliers, brands, categories…',
  SUPPLIERS_PREMIER_TITLE: 'Premier suppliers',
  SUPPLIERS_PREMIER_LEAD: 'Top-rated partners with priority fulfilment.',
  SUPPLIERS_ALL_TITLE: 'All suppliers',
  SUPPLIERS_ALL_LEAD_one: '{{count}} verified supplier',
  SUPPLIERS_ALL_LEAD_other: '{{count}} verified suppliers',
  SUPPLIERS_VIEW_STORE: 'View store',
  SUPPLIERS_PREMIER_BADGE: 'Premier',
  SUPPLIERS_VERIFIED: 'Verified',
  BUYER_NAV_SUPPLIERS: 'Suppliers',
  SUPPLIER_BACK_TO_CATALOGUE: 'Back to catalogue',
  SUPPLIER_BACK_TO_DIRECTORY: 'Back to suppliers',
  SUPPLIER_BRAND_LABEL: 'Supplier',
  SUPPLIER_PRODUCTS_COUNT: 'Products',
  SUPPLIER_PRODUCTS_TITLE: 'Products from {{name}}',
  SUPPLIER_NO_PRODUCTS: 'This supplier has no products available right now.',
  SUPPLIER_VERIFIED: 'Verified',
  SUPPLIER_FOLLOW: 'Follow',
  SUPPLIER_FOLLOWING: 'Following',
  SUPPLIER_BROWSE_ALL_one: 'Browse all {{count}}',
  SUPPLIER_BROWSE_ALL_other: 'Browse all {{count}}',
  SUPPLIER_SEARCH_WITHIN: 'Search within this supplier',
  SUPPLIER_FILTER_IN_STOCK: 'In stock only',
  SUPPLIER_NO_RESULTS: 'No products match your filters.',

  NOTIFICATIONS_TITLE: 'Notifications',
  NOTIFICATIONS_SUBTITLE_one: '{{count}} unread message',
  NOTIFICATIONS_SUBTITLE_other: '{{count}} unread messages',
  NOTIFICATIONS_FILTER_UNREAD: 'Unread',
  NOTIFICATIONS_EMPTY: 'You are all caught up.',
  NOTIFICATIONS_TODAY: 'Today',
  NOTIFICATIONS_YESTERDAY: 'Yesterday',
  NOTIFICATIONS_EARLIER: 'Earlier',

  NOTIFICATION_TITLE_BUSINESS_REGISTERED: 'Business created',
  NOTIFICATION_BODY_BUSINESS_REGISTERED: '{{businessName}} is now registered.',
  NOTIFICATION_TITLE_BUSINESS_INVITATION_RECEIVED: 'You have a new invitation',
  NOTIFICATION_BODY_BUSINESS_INVITATION_RECEIVED:
    '{{invitedBy}} invited you to join {{businessName}}.',
  NOTIFICATION_TITLE_BUSINESS_INVITATION_ACCEPTED: 'Invitation accepted',
  NOTIFICATION_BODY_BUSINESS_INVITATION_ACCEPTED:
    '{{invitedBy}} has joined {{businessName}}.',
  NOTIFICATION_TITLE_BUSINESS_MEMBER_REMOVED: 'Member removed',
  NOTIFICATION_BODY_BUSINESS_MEMBER_REMOVED:
    'A member was removed from {{businessName}}.',
  NOTIFICATION_TITLE_BUSINESS_MEMBER_LEFT: 'Member left',
  NOTIFICATION_BODY_BUSINESS_MEMBER_LEFT:
    'A member has left {{businessName}}.',

  NOTIFICATION_TITLE_ORDER_CREATED: 'Order placed',
  NOTIFICATION_BODY_ORDER_CREATED: 'Order {{orderNumber}} is awaiting payment.',
  NOTIFICATION_TITLE_ORDER_PAID: 'Payment received',
  NOTIFICATION_BODY_ORDER_PAID: 'Order {{orderNumber}} has been paid.',
  NOTIFICATION_TITLE_ORDER_DISPATCHED: 'Order dispatched',
  NOTIFICATION_BODY_ORDER_DISPATCHED:
    'Order {{orderNumber}} is on the way via {{carrier}} ({{trackingNumber}}).',
  NOTIFICATION_TITLE_ORDER_CANCELLED: 'Order cancelled',
  NOTIFICATION_BODY_ORDER_CANCELLED: 'Order {{orderNumber}} was cancelled.',
  NOTIFICATION_TITLE_ORDER_EXPIRED: 'Order expired',
  NOTIFICATION_BODY_ORDER_EXPIRED:
    'Order {{orderNumber}} expired because payment was not received in time.',
  NOTIFICATION_TITLE_ORDER_PAYMENT_FAILED: 'Payment failed',
  NOTIFICATION_BODY_ORDER_PAYMENT_FAILED:
    'Payment for order {{orderNumber}} failed. {{reason}}',

  NOTIFICATION_TITLE_VIRTUAL_PRODUCT_DELIVERED: 'Access delivered',
  NOTIFICATION_BODY_VIRTUAL_PRODUCT_DELIVERED:
    'Access details for {{productName}} have been emailed to you.',
  NOTIFICATION_TITLE_VIRTUAL_PRODUCT_DELIVERY_FAILED: 'Delivery failed — retrying',
  NOTIFICATION_BODY_VIRTUAL_PRODUCT_DELIVERY_FAILED:
    'We could not deliver access for {{productName}}. {{reason}}',
  NOTIFICATION_TITLE_VIRTUAL_PRODUCT_AUTO_DELISTED: 'Training course closed',
  NOTIFICATION_BODY_VIRTUAL_PRODUCT_AUTO_DELISTED:
    '{{productName}} is no longer available for new purchases.',

  NOTIFICATION_TITLE_GUEST_ORDER_CREATED: 'Guest order placed',
  NOTIFICATION_BODY_GUEST_ORDER_CREATED: 'Guest order {{orderNumber}} created.',
  NOTIFICATION_TITLE_GUEST_ORDER_PAID: 'Guest order paid',
  NOTIFICATION_BODY_GUEST_ORDER_PAID: 'Guest order {{orderNumber}} has been paid.',
  NOTIFICATION_TITLE_GUEST_ORDER_DISPATCHED: 'Guest order dispatched',
  NOTIFICATION_BODY_GUEST_ORDER_DISPATCHED:
    'Guest order {{orderNumber}} is on the way.',
  ADD_TO_CART: 'Add to cart',
  BUY_NOW: 'Buy now',
  PER_UNIT: 'per {{unit}}',
  MOQ: 'Minimum order qty',
  MOQ_X: 'MOQ {{count}}',
  GST_RATE: 'GST rate',
  AVAILABLE_STOCK: 'Available stock',
  BACK_TO_PRODUCTS: 'Back to products',
  NO_IMAGE: 'No image',

  CART_TITLE: 'Cart',
  CART_DESC: 'Review and adjust items before checkout.',
  CART_EMPTY_TITLE: 'Your cart is empty',
  CART_EMPTY_DESC: 'Add products to start an order.',
  CART_ADDED: 'Added "{{name}}" to cart',
  CART_IN_CART_QTY_one: '{{count}} added',
  CART_IN_CART_QTY_other: '{{count}} added',
  CART_ADD_FAILED: 'Failed to add to cart',
  CART_UPDATE_FAILED: 'Failed to update cart',
  CART_UPDATE: 'Update cart',
  CART_UPDATE_SHORT: 'Update',
  ADD_TO_CART_SHORT: 'Add',
  BUY_NOW_SHORT: 'Buy',
  GO_TO_CART: 'Go to cart',
  IN_CART_GO_TO_CART: 'In cart ({{count}}) · go to cart →',
  CART_HAS_CONFLICTS: 'Cart has issues — please resolve them before checkout',
  CART_CONFLICTS_TITLE: 'Cart issues',
  CART_STOCK_CLAMP_TITLE: 'Some quantities were reduced to match available stock.',
  CART_CHECKOUT_HINT: "You'll review shipping & payment next",
  CART_DISMISS: 'Dismiss',
  CART_CLAMP_SUMMARY:
    '{{clamped}} line(s) clamped to available stock. {{removed}} line(s) no longer available. Review before checkout.',
  CART_SAVE_AS_TEMPLATE: 'Save as template',
  CART_SAVE_AS_TEMPLATE_TIP: 'Coming soon',
  CART_CONTINUE_TO_CHECKOUT: 'Continue to checkout',
  CART_SUBTOTAL_WITH_COUNT_one: 'Subtotal ({{count}} item)',
  CART_SUBTOTAL_WITH_COUNT_other: 'Subtotal ({{count}} items)',
  CART_SUBTOTAL_WITH_COUNT: 'Subtotal ({{count}} items)',
  CART_FREIGHT_ESTIMATE: 'Freight (estimate)',
  MIN_PHYSICAL_ORDER_NOTICE: 'Product subtotal must reach {{amount}} before checkout.',
  FREE_SHIPPING_OVER_THRESHOLD: 'Free shipping on product orders over {{amount}}.',
  CART_DISCOUNT: 'Discount',
  CART_TOTAL_WITH_GST: 'Total (incl. GST)',
  CART_TRUST_TITLE: 'No oversells, ever.',
  CART_TRUST_BODY:
    "Stock is re-checked at checkout. If anything changes, you'll see exactly what before paying.",
  RECHECK_STOCK: 'Re-check stock',
  PRODUCT: 'Product',
  QUANTITY: 'Quantity',
  UNIT_PRICE: 'Unit price',
  NOTIFY_ME: 'Notify',
  CART_ROW_IN_STOCK: '{{count}} in stock',
  CART_ROW_REDUCED: 'Reduced from {{from}} — only {{max}} in stock',
  CART_ROW_NO_LONGER_STOCK: 'No longer in stock',
  ITEMS_COUNT_one: '{{count}} item',
  ITEMS_COUNT_other: '{{count}} items',
  ITEMS_COUNT: '{{count}} items',
  SYDNEY_WAREHOUSE: 'Sydney warehouse',
  PROCEED_TO_CHECKOUT: 'Proceed to checkout',
  VALIDATING: 'Validating…',
  BROWSE_PRODUCTS: 'Browse products',
  CONTINUE_SHOPPING: 'Continue shopping',

  CHECKOUT_TITLE: 'Checkout',
  CHECKOUT_DESC: 'Confirm your shipping address and place the order.',
  CHECKOUT_STEP_LABEL: 'STEP {{n}}',
  CHECKOUT_STEP_1_TITLE: 'Review',
  CHECKOUT_STEP_1_SUMMARY_one: 'Review · {{count}} item · stock confirmed',
  CHECKOUT_STEP_1_SUMMARY_other: 'Review · {{count}} items · stock confirmed',
  CHECKOUT_STEP_1_SUMMARY: 'Review · {{count}} items · stock confirmed',
  CHECKOUT_STEP_2_TITLE: 'Shipping & freight',
  CHECKOUT_STEP_2_TITLE_VIRTUAL: 'Delivery email',
  DELIVERY_EMAIL_LABEL: 'Delivery email',
  DELIVERY_EMAIL_HELP: 'Training courses will be sent to this email after payment.',
  DELIVERY_EMAIL_INVALID: 'Please enter a valid email address.',
  ORDER_DELIVERY_EMAIL: 'DELIVERY EMAIL',
  ORDER_DELIVERY_EMAIL_HELP: 'Training courses are sent to this email.',
  CHECKOUT_STEP_3_TITLE: 'How would you like to pay?',
  CHECKOUT_STEP_OF: 'Step {{n}} of {{total}}',
  CHECKOUT_STEP_ACCOUNT_TITLE: 'Your details',
  CHECKOUT_STEP_ADDRESS_TITLE: 'Shipping & billing',
  CHECKOUT_STEP_CONFIRM_TITLE: 'Review your order',
  CHECKOUT_CONFIRM_ITEMS: 'Items in this order',
  CHECKOUT_CREATE_ACCOUNT: 'Create account',
  CHECKOUT_CREATING_ACCOUNT: 'Creating account…',
  CHECKOUT_CREATE_ACCOUNT_HINT:
    'Create your account to continue. You will be signed in automatically.',
  CHECKOUT_BACK: 'Back',
  CHECKOUT_CONTINUE: 'Continue',
  CHECKOUT_ACCOUNT_CREATED: 'Account created. You are now signed in.',
  CHECKOUT_EDIT: 'Edit',
  CHECKOUT_DEFAULT_ADDRESS: 'Default',
  CHECKOUT_FREIGHT_OPTION: 'Standard freight',
  CHECKOUT_FREIGHT_EXPRESS: 'Express freight',
  CHECKOUT_FREIGHT_PROVIDER: 'StarTrack',
  CHECKOUT_FREIGHT_ETA: 'ETA {{date}}',
  CHECKOUT_FREIGHT_NOTE: 'signature on delivery',
  CHECKOUT_BILLING_ADDRESS: 'Billing address',
  CHECKOUT_BILLING_SAME: 'Same as shipping address',
  CHECKOUT_BILLING_ENTER: 'Please enter billing address',
  CHECKOUT_BILLING_CHANGE: 'Change',
  CHECKOUT_DONE_EDITING: 'Done',
  CHECKOUT_PAYMENT_METHOD: 'PAYMENT METHOD',
  CHECKOUT_ADD_CARD: 'Add new card',
  CHECKOUT_CARDHOLDER: 'Cardholder name',
  CHECKOUT_CARD_NUMBER: 'Card number',
  CHECKOUT_EXPIRY: 'Expiry',
  PRICE_CONTACT_PLATFORM: 'Please contact platform',
  CHECKOUT_CVC: 'CVC',
  CHECKOUT_SAVE_CARD: 'Save this card for future orders',
  CHECKOUT_PAY_SECURELY: 'Pay {{amount}} securely',
  CHECKOUT_TERMS_BLURB:
    "By paying, you agree to VMall's Order Terms. Stock is reserved for 8 minutes from this step.",
  CHECKOUT_PCI_TITLE: 'PCI compliant.',
  CHECKOUT_PCI_BODY:
    'Card details are tokenised by Stripe — never stored on VMall servers.',
  CHECKOUT_VISA: 'VISA',
  CHECKOUT_REMOVE_CARD: 'Remove this card',
  CHECKOUT_MASTERCARD: 'MASTERCARD',
  CHECKOUT_CARD_EXPIRES: 'Expires {{date}}',
  SHIPPING_ADDRESS: 'Shipping address',
  SHIPPING_ADDRESS_INCOMPLETE: 'Shipping address is incomplete',
  ORDER_ITEMS: 'Order items',
  ORDER_SUMMARY: 'Order summary',
  SUBTOTAL: 'Subtotal',
  GST: 'GST',
  TOTAL: 'Total',
  PLACE_ORDER: 'Place order',
  ORDER_TOTAL: 'Total',
  PLACING_ORDER: 'Placing order…',
  BACK_TO_CART: 'Back to cart',
  ORDER_CREATED: 'Payment successful — order placed',
  ORDER_CREATE_FAILED: 'Failed to place order',

  CONTACT_NAME: 'Contact name',
  CONTACT_PHONE: 'Contact phone',
  ADDRESS_LINE1: 'Address line 1',
  ADDRESS_LINE2: 'Address line 2',
  SUBURB: 'Suburb',
  STATE: 'State',
  POSTCODE: 'Postcode',
  COUNTRY: 'Country',

  ORDERS_TITLE: 'All orders',
  ORDERS_PAGE_SUBTITLE: 'Across your business & users · last 12 months',
  ORDERS_TOTAL_COUNT: '{{count}} total',
  ORDERS_EXPORT_CSV: 'Export CSV',
  ORDERS_NEW_ORDER: 'Go shopping',
  ORDERS_DATE_RANGE_PLACEHOLDER: 'Apr 1 — May 6',
  ORDERS_PLACED_BY: 'Placed by: All',
  ORDERS_SHIP_TO: 'Ship to: All',
  ORDERS_SAVED_VIEWS: 'Saved views:',
  ORDERS_VIEW_OPEN: 'Open orders',
  ORDERS_VIEW_Q2_REORDERS: 'Q2 reorders',
  ORDERS_TAB_ALL: 'All',
  ORDER_REORDER: 'Reorder',
  ORDER_BUY_AGAIN: 'Buy again',
  ORDER_AND_MORE_ITEMS: 'and {{count}} more',
  ORDER_PLACED_AT_LABEL: 'Placed',
  ORDER_CARRIER_LABEL: 'Carrier',
  ORDER_SHIP_TO_LABEL: 'Ship to',
  ORDER_VIEW_LOGISTICS: 'View logistics',
  ORDER_MORE: 'More',
  ORDER_PAID_AMOUNT: 'Paid',
  ORDER_SHOP_FALLBACK: 'Vmall Store',
  ORDER_DOWNLOAD_INVOICE: 'Download invoice',
  ORDER_INVOICE_COMING_SOON: 'Invoice download coming soon',
  ORDER_REORDER_DONE: 'Added {{count}} item(s) to cart',
  ORDER_SHIP_TO_COL: 'Ship to',
  ORDER_PLACED_BY_COL: 'Placed by',
  ORDER_DATE_COL: 'Date',
  ORDER_GUEST: 'Guest',

  ORDER_HERO_NUMBER: 'ORDER NUMBER',
  ORDER_HERO_PLACED: 'PLACED',
  ORDER_HERO_STATUS: 'STATUS',
  ORDER_PRINT: 'Print',
  ORDER_INVOICE: 'Invoice',
  ORDER_TRACKING_TIMELINE: 'Tracking timeline',
  ORDER_CARRIER: 'Carrier',
  ORDER_TRACKING_NUMBER: 'Tracking number',
  ORDER_ITEMS_LINES_one: '{{lines}} line · {{boxes}} boxes',
  ORDER_ITEMS_LINES_other: '{{lines}} lines · {{boxes}} boxes',
  ORDER_ITEMS_LINES: '{{lines}} lines · {{boxes}} boxes',
  ORDER_BILL_TO: 'BILL TO',
  ORDER_BILLING_SAME_AS_SHIPPING: 'Same as shipping address',
  ORDER_SHIP_TO: 'SHIP TO',
  ORDER_SHIPPING_METHOD: 'SHIPPING METHOD',
  ORDER_SHIPPING_METHOD_LABEL: 'Shipping method',
  ORDER_NOTES: 'ORDER NOTES',
  ORDER_NOTES_LABEL: 'Notes',
  ORDER_PAYMENT: 'PAYMENT',
  ORDER_SUMMARY_LABEL: 'SUMMARY',
  ORDER_PAID_BADGE: 'Paid',
  ORDER_FREIGHT: 'Freight',
  ORDER_PO_NUMBER: 'PO #',
  ORDER_ABN_LABEL: 'ABN',
  ORDER_PAID_AT: 'Charged · {{time}}',
  ORDER_ETA_PREFIX: 'ETA',

  ORDER_TRACK_PLACED: 'Order placed',
  ORDER_TRACK_PROCESSING: 'Processing',
  ORDER_TRACK_PACKED: 'Packed',
  ORDER_TRACK_TRANSIT: 'In transit',
  ORDER_TRACK_OUT_FOR_DELIVERY: 'Out for delivery',
  ORDER_TRACK_DELIVERED: 'Delivered',
  ORDER_TRACK_PENDING: 'Pending',
  ORDER_TRACK_EXPECTED: 'Expected {{date}}',
  ORDERS_DESC: 'Your order history.',
  ORDERS_EMPTY_TITLE: 'No orders yet',
  ORDERS_EMPTY_DESC: 'Place your first order from the products page.',
  BACK_TO_ORDERS: 'Back to orders',
  ORDER_ID: 'Order ID',
  CREATED_AT: 'Created at',
  ITEMS: 'Items',
  STATUS: 'Status',
  ORDER_TIMELINE: 'Timeline',
  TRACKING: 'Tracking',

  ORDER_PENDING_PAYMENT: 'Pending payment',
  ORDER_PAID: 'Paid',
  ORDER_PROCESSING: 'Processing',
  ORDER_DISPATCHED: 'Dispatched',
  ORDER_RECEIVED: 'Received',
  ORDER_COMPLETED: 'Completed',
  ORDER_CANCELLED: 'Cancelled',
  ORDER_PAYMENT_FAILED: 'Payment failed',
  ORDER_EXPIRED: 'Expired',

  PAYMENT_COUNTDOWN: 'Reservation expires in {{time}}. Please complete payment.',
  PAYMENT_SUCCESS: 'Payment successful',
  PAYMENT_FAILED_NOTI: 'Payment failed. Please try again or contact support.',
  PAY_NOW: 'Pay now',
  PAYING: 'Paying…',
  CANCELLING: 'Cancelling…',
  MOCK_PAYMENT_HINT: 'Dev environment — pick a payment outcome:',
  SIMULATE_PAY_SUCCESS: 'Simulate payment success',
  SIMULATE_PAY_FAILURE: 'Simulate payment failure',
  CANCEL_ORDER: 'Cancel order',
  CANCEL_ORDER_CONFIRM_TITLE: 'Cancel this order?',
  CANCEL_ORDER_CONFIRM_DESC: 'Reserved stock will be released. This cannot be undone.',
  ORDER_CANCELLED_NOTI: 'Order cancelled',
  ORDER_CANCEL_FAILED: 'Failed to cancel order',

  SEARCH_ORDERS: 'Search by order ID',
  ORDER_STATUS_ALL: 'All statuses',

  PAYMENTS_TITLE: 'Payments',
  PAYMENTS_DESC: 'Your payment records.',
  PAYMENTS_EMPTY_TITLE: 'No payments yet',
  PAYMENTS_EMPTY_DESC: 'Payment records appear after you place a paid order.',
  SEARCH_PAYMENTS: 'Search by payment or order ID',
  PAYMENT_STATUS_ALL: 'All statuses',
  PAYMENT_STATUS_PAID: 'Paid',
  PAYMENT_STATUS_PENDING: 'Pending',
  PAYMENT_STATUS_FAILED: 'Failed',
  PAYMENT_STATUS_REFUNDED: 'Refunded',
  PAYMENT_STATUS_CANCELLED: 'Cancelled',
  PAYMENT_ID: 'Payment ID',
  AMOUNT: 'Amount',
  PAYMENT_METHOD: 'Method',
  PAID_AT: 'Paid at',
  BACK_TO_PAYMENTS: 'Back to payments',
  DOWNLOAD_INVOICE: 'Download invoice',
  DOWNLOADING: 'Downloading…',
  INVOICE_DOWNLOAD_FAILED: 'Failed to download invoice',
  INVOICE_MOCK_HINT: 'Mock invoice — a plain text file will be generated.',

  CONFIRM_RECEIVED: 'Confirm received',
  CONFIRM_RECEIVED_TITLE: 'Confirm goods received?',
  CONFIRM_RECEIVED_DESC: 'This will mark the order as completed.',
  ORDER_RECEIVED_NOTI: 'Order marked as received',
  ORDER_RECEIVED_FAILED: 'Failed to confirm receipt',

  REORDER: 'Add to cart again',
  REORDERING: 'Adding to cart…',
  REORDER_SUCCESS: 'Added {{count}} item(s) to your cart',
  REORDER_PARTIAL: 'Added {{added}} item(s); {{skipped}} skipped due to stock changes',
  REORDER_ALL_SKIPPED: 'No items could be re-added — current stock unavailable',
  REORDER_FAILED: 'Failed to reorder',

  DEV_TOOLS_HINT: 'Dev tools (mock only) — no warehouse portal yet:',
  DEV_SIMULATE_DISPATCH: 'Simulate dispatch',
  DEV_DISPATCHING: 'Dispatching…',
  DEV_DISPATCH_DONE: 'Order marked as dispatched (mock)',

  PROFILE_TITLE: 'Profile',
  PROFILE_DESC: 'Your account and business information.',
  USER_INFO: 'User',
  NAME: 'Name',
  ROLE: 'Role',
  CLINIC_INFO: 'Business',
  CLINIC_NAME: 'Business name',
  ABN: 'ABN',
  CLINIC_EMAIL: 'Contact email',
  CLINIC_PHONE: 'Contact phone',
  BILLING_ADDRESS: 'Billing address',
  NOT_SET: 'Not set',
  EDIT_ADDRESSES: 'Edit addresses',
  CLINIC_STATUS_ACTIVE: 'Active',
  CLINIC_STATUS_PENDING_REVIEW: 'Pending review',
  CLINIC_STATUS_DISABLED: 'Disabled',
  CLINIC_STATUS_REJECTED: 'Rejected',

  ADDRESSES_DESC: 'Update billing and shipping addresses for future orders.',
  BACK_TO_PROFILE: 'Back to profile',
  COPY_FROM_BILLING: 'Copy from billing',
  BILLING_ADDRESS_INCOMPLETE: 'Billing address is incomplete',
  SAVE_ADDRESSES: 'Save addresses',
  ADDRESSES_SAVED: 'Addresses saved',
  ADDRESSES_SAVE_FAILED: 'Failed to save addresses',

  BUYER_NAV_PRODUCTS: 'Products',
  BUYER_NAV_CATALOGUE: 'Catalogue',
  BUYER_NAV_CART: 'Cart',
  BUYER_NAV_ORDERS: 'Orders',
  BUYER_NAV_PAYMENTS: 'Payments',
  BUYER_NAV_PROFILE: 'Business profile',
  BUYER_NAV_PROFILE_PERSONAL: 'Personal profile',
  BUYER_NAV_ADDRESSES: 'Addresses',
  BUYER_NAV_NOTIFICATIONS: 'Notifications',
  BUYER_NAV_DASHBOARD: 'Shopping history',
  BUYER_NAV_TRACK_ORDER: 'Track order',
  BUYER_NAV_GROUP_WORKSPACE: 'Workspace',
  BUYER_NAV_GROUP_RECORDS: 'Records',
  BUYER_NAV_GROUP_ACCOUNT: 'Account',
  SIDEBAR_NEED_HELP: 'Need help?',
  SEARCH_PLACEHOLDER_TOPBAR: 'Search SKU, order, invoice',
  FILTERS: 'Filters',
  FILTERS_APPLY: 'Apply',

  DASHBOARD_GREETING: 'Good morning, {{name}} 👋',
  DASHBOARD_SUBTITLE: "Here's what's happening at {{clinic}}.",
  DASHBOARD_EXPORT: 'Export report',
  DASHBOARD_NEW_ORDER: 'Go shopping',
  DASHBOARD_OPEN_ORDERS: 'Open orders',
  DASHBOARD_IN_TRANSIT: 'In transit',
  DASHBOARD_MONTH_SPEND: 'This month spend',
  DASHBOARD_STOCK_ALERTS: 'Stock alerts',
  DASHBOARD_QUICK_REORDER: 'Quick reorder',
  DASHBOARD_QUICK_REORDER_HINT: 'Your most-ordered items, last 90 days',
  DASHBOARD_VIEW_ALL: 'View all →',
  DASHBOARD_RECENT_ORDERS: 'Recent orders',
  DASHBOARD_ALL_ORDERS: 'All orders →',
  DASHBOARD_STOCK_REMINDERS: 'Stock reminders',
  DASHBOARD_RECENTLY_RESTOCKED: 'Recently restocked',
  DASHBOARD_NOTIFICATIONS: 'Notifications',
  DASHBOARD_MARK_ALL_READ: 'Mark all read',
  DASHBOARD_REVIEW_NOW: 'Review now →',
  DASHBOARD_SINCE_YESTERDAY: '+1 since yesterday',
  DASHBOARD_VS_LAST_MONTH: '+12% vs last month',
  DASHBOARD_ETA: 'ETA',
  DASHBOARD_REORDER_X: 'Reorder × {{count}}',
  DASHBOARD_NOTIFY_ME: 'Notify me',
  DASHBOARD_LOW: 'Low',
  DASHBOARD_OOS: 'OOS',
  DASHBOARD_LAST_ORD: 'last ord {{days}}d ago',
  DASHBOARD_BACK_SINCE: 'back since {{when}}',
  DASHBOARD_BACK_TODAY: 'back today',
  DASHBOARD_GREETING_DR_NAME: '{{name}}',
  DASHBOARD_GREETING_FALLBACK: 'there',
  DASHBOARD_CLINIC_FALLBACK: 'your business',
  DASHBOARD_ETA_DATE_PLACEHOLDER: 'Wed 06 May',
  DASHBOARD_ORDER_STATUS_IN_TRANSIT: 'In transit',
  DASHBOARD_ORDER_STATUS_PACKED: 'Packed',
  DASHBOARD_ORDER_STATUS_PROCESSING: 'Processing',
  DASHBOARD_ORDER_STATUS_DELIVERED: 'Delivered',
  DASHBOARD_DAY_MON: 'Mon',
  DASHBOARD_DAY_TUE: 'Tue',
  DASHBOARD_WHEN_MIN_one: '{{count}} min',
  DASHBOARD_WHEN_MIN_other: '{{count}} min',
  DASHBOARD_WHEN_HOUR_one: '{{count}} h',
  DASHBOARD_WHEN_HOUR_other: '{{count}} h',
  DASHBOARD_NOTIF_TITLE_ORDER_SHIPPED: 'Order shipped',
  DASHBOARD_NOTIF_DESC_ORDER_SHIPPED: '{{orderId}} — {{cartons}} cartons',
  DASHBOARD_NOTIF_TITLE_PAYMENT_RECEIVED: 'Payment received',
  DASHBOARD_NOTIF_DESC_PAYMENT_RECEIVED: '{{orderId}} — {{amount}}',
  DASHBOARD_NOTIF_TITLE_STOCK_LOW: 'Stock low',
  DASHBOARD_NOTIF_DESC_STOCK_LOW: '{{product}} — {{units}} units',
  DASHBOARD_NO_RECENT_ORDERS: 'No orders yet. Browse the catalogue to place your first order.',
  NOTIFICATIONS_PAGE_TITLE: 'Notifications',
  NOTIFICATIONS_UNREAD_SUMMARY: '{{unread}} unread · {{total}} in last 30 days',
  NOTIFICATIONS_PREFERENCES: 'Preferences',
  NOTIFICATIONS_FILTER_ALL: 'All',
  NOTIFICATIONS_FILTER_ORDERS: 'Orders',
  NOTIFICATIONS_FILTER_STOCK: 'Stock',
  NOTIFICATIONS_FILTER_PAYMENTS: 'Payments',
  NOTIFICATIONS_FILTER_SYSTEM: 'System',
  NOTIFICATIONS_FILTER_CRITICAL: 'Critical',
  NOTIFICATIONS_QUIET_HOURS: 'Quiet hours active',
  NOTIFICATIONS_QUIET_HOURS_DESC:
    'Email digests pause from 18:00 — 08:00. Critical alerts always come through.',
  NOTIFICATIONS_MARK_ALL_READ: 'Mark all read',
  NOTIFICATIONS_REFRESH: 'Refresh',
  NOTIFICATIONS_VIEW_LINK: 'View →',
  NOTIFICATIONS_CRITICAL_BADGE: 'Critical · action required',
  NOTIFICATIONS_GROUP_TODAY: 'Today · 6 May',
  NOTIFICATIONS_GROUP_YESTERDAY: 'Yesterday · 5 May',
  NOTIFICATIONS_GROUP_EARLIER: 'Earlier this week',
  NOTIFICATIONS_CRITICAL_ALERT_TITLE: '⚠ {{count}} critical alert needs action',
  NOTIFICATIONS_REVIEW_RECALL: 'Review recall →',
  NOTIFICATIONS_FILTER_PANEL_TITLE: 'Filters',
  NOTIFICATIONS_STATUS_LABEL: 'Status',
  NOTIFICATIONS_PRIORITY_LABEL: 'Priority',
  NOTIFICATIONS_STATUS_ALL: 'All',
  NOTIFICATIONS_STATUS_UNREAD: 'Unread only',
  NOTIFICATIONS_STATUS_READ: 'Read only',
  NOTIFICATIONS_PRIORITY_CRITICAL: 'Critical',
  NOTIFICATIONS_PRIORITY_HIGH: 'High',
  NOTIFICATIONS_PRIORITY_MEDIUM: 'Medium',
  NOTIFICATIONS_PRIORITY_LOW: 'Low',

  GUEST_MODE: 'Browsing as guest',
  GUEST_MODE_BANNER: 'Guest checkout',
  GUEST_CONTACT_INCOMPLETE: 'Please fill in your contact details',
  GUEST_EMAIL_INVALID: 'Please enter a valid email address',
  GUEST_EMAIL_HELP: 'Used to send your receipt and look up this order later.',
  CONTACT_DETAILS: 'Contact details',
  FIRST_NAME: 'First name',
  LAST_NAME: 'Last name',
  PHONE: 'Phone',
  CLINIC_NAME_OPTIONAL: 'Business name (optional)',
  CREATE_ACCOUNT_WITH_EMAIL: 'Create an account with this email',
  PASSWORD_MIN_8: 'At least 8 characters.',
  PASSWORD_TOO_SHORT: 'Password must be at least 8 characters',

  ORDER_LOOKUP_TITLE: 'Track order',
  ORDER_LOOKUP_RESULT_TITLE: 'Order detail',
  ORDER_LOOKUP_DESC:
    'Enter the order number you received in your confirmation email along with the email address used to place the order.',
  ORDER_LOOKUP_FAILED:
    'No order matched. Check the order number and email and try again.',
  ORDER_LOOKUP_MISSING_EMAIL: 'Email is required to view this order.',
  ORDER_ID_PLACEHOLDER: 'e.g. o-xxxxxxxx',
  LOOK_UP_ORDER: 'Look up order',
  LOADING: 'Loading…',

  CONFIRMATION_EMAIL_SENT: 'An order confirmation email has been sent to {{email}}.',
  RESEND_EMAIL: 'Resend email',
  RESEND_IN_SECONDS: 'Resend in {{seconds}}s',
  SENDING: 'Sending…',
  RECEIPT_RESENT: 'Receipt email sent',
  RECEIPT_RESEND_FAILED: 'Could not resend the receipt email',

  // V2.2 — Buyer Portal naming (additions; the matching CLINIC_* → BUYER_* keys are above)
  BUYER_PORTAL_TITLE: 'Buyer Portal',
  BUYER_NAV_GROUP_BUSINESS: 'Business',
  BUYER_NAV_BUSINESS: 'Business',
  BUYER_NAV_BUSINESS_MEMBERS: 'Members',
  BUYER_NAV_BUSINESS_INVITATIONS: 'Invitations',

  // Identity chrome
  BUYER_IDENTITY_TITLE: 'Buyer identity',
  BUYER_IDENTITY_OWNER: 'Owner',
  BUYER_IDENTITY_MEMBER: 'Member',
  BUYER_IDENTITY_PERSONAL: 'Personal account',
  BUYER_IDENTITY_MANAGE_BUSINESS: 'Manage Business',
  BUYER_IDENTITY_INDIVIDUAL_HINT:
    'You are using VMall as an individual buyer. Create or join a Business to manage shared orders.',
  BUYER_IDENTITY_CREATE_OR_JOIN: 'Create or join a Business',

  DEFAULT_BILLING_ADDRESS: 'Default billing address',
  DEFAULT_SHIPPING_ADDRESS: 'Default shipping address',

  // Onboarding
  ONBOARDING_TITLE: 'Welcome to VMall',
  ONBOARDING_SUBTITLE: 'Choose how you want to use the platform.',
  ONBOARDING_PERSONAL_TITLE: 'Continue as personal',
  ONBOARDING_PERSONAL_BODY:
    'Place orders under your personal account. You can create or join a Business later.',
  ONBOARDING_PERSONAL_CTA: 'Continue',
  ONBOARDING_BUSINESS_TITLE: 'Set up your Business',
  ONBOARDING_BUSINESS_BODY:
    'Manage shared orders, members, and Business invoices for your team.',
  ONBOARDING_BUSINESS_CTA: 'Create a Business',
  BUSINESS_CREATE_TITLE: 'Create a Business',
  BUSINESS_CREATE_DESC:
    'Give your Business a name to get started. You can add details like ABN and addresses later.',
  BUSINESS_CREATE_NAME_LABEL: 'Business name',
  BUSINESS_CREATE_NAME_PLACEHOLDER: 'e.g. Riverside Medical Clinic',
  BUSINESS_CREATE_SUBMIT: 'Create Business',
  BUSINESS_CREATING: 'Creating…',
  BUSINESS_CREATE_SUCCESS: '{{name}} created. You are now the Owner.',
  BUSINESS_CREATE_FAILED: 'Failed to create Business. Please try again.',
  ONBOARDING_INVITATION_TITLE: 'I have an invitation',
  ONBOARDING_INVITATION_BODY:
    'Paste the invitation token your Business Owner shared with you.',
  ONBOARDING_INVITATION_TOKEN_LABEL: 'Invitation token',
  ONBOARDING_INVITATION_CTA: 'Accept invitation',
  ONBOARDING_ACCEPTING: 'Accepting…',
  ONBOARDING_FOOTER_HINT:
    'You can switch between personal and Business at any time from your profile.',

  // Invitation accept landing
  INVITATION_PREVIEW_LABEL: 'BUSINESS INVITATION',
  INVITATION_INVITE_HEADING: '{{name}} invited you to join their Business on VMall.',
  INVITATION_INVITED_EMAIL_LINE: 'Invitation sent to {{email}}',
  INVITATION_EXPIRES_LINE: 'This invitation expires {{date}}.',
  INVITATION_LOGIN_REQUIRED: 'Sign in to an existing account, or create a new one, to join this Business.',
  INVITATION_SIGN_IN_AND_JOIN: 'Sign in & join',
  INVITATION_REGISTER_AND_JOIN: 'Create account & join',
  INVITATION_ACCEPT_CTA: 'Accept invitation',
  INVITATION_ACCEPTED: 'You have joined {{name}}.',
  INVITATION_ACCEPT_FAILED: 'Could not accept the invitation.',

  // Business profile / members / invitations
  BUSINESS_TITLE: 'Business',
  BUSINESS_IDENTITY: 'Business identity',
  BUSINESS_NAME: 'Business name',
  BUSINESS_INDUSTRY: 'Industry',
  BUSINESS_CONTACT_PERSON: 'Primary contact',
  BUSINESS_PHONE: 'Business phone',
  BUSINESS_EMAIL: 'Business email',
  BUSINESS_EDIT: 'Edit',
  BUSINESS_MEMBERS: 'Members',
  BUSINESS_INVITATIONS: 'Invitations',
  BUSINESS_NOT_MEMBER_TITLE: 'You are not in a Business',
  BUSINESS_NOT_MEMBER_DESC:
    'Create a Business or accept an invitation to manage shared orders.',
  BUSINESS_SAVED: 'Business profile saved.',
  BUSINESS_SAVE_FAILED: 'Could not save the Business profile.',
  BUSINESS_FORM_INCOMPLETE: 'Please complete all required fields.',
  BUSINESS_STATUS_ACTIVE: 'Active',
  BUSINESS_STATUS_PENDING_REVIEW: 'Pending review',
  BUSINESS_STATUS_DISABLED: 'Disabled',
  BUSINESS_STATUS_REJECTED: 'Rejected',
  BUSINESS_ADDRESS_MISSING_BANNER: 'Billing or shipping address is missing. Complete them so future orders can be placed and shipped.',
  BUSINESS_ADDRESS_MISSING_ACTION: 'Complete now',
  BUSINESS_LEFT: 'You have left the Business.',
  BUSINESS_LEAVE_FAILED: 'Could not leave the Business.',
  BUSINESS_LEAVE_TITLE: 'Leave Business',
  BUSINESS_LEAVE_OWNER_HINT:
    'You are the Owner. The sole Owner cannot leave; promote another Owner first.',
  BUSINESS_LEAVE_MEMBER_HINT:
    'After leaving, you will lose visibility on orders placed under this Business.',
  BUSINESS_LEAVE: 'Leave Business',
  BUSINESS_LEAVE_CONFIRM_TITLE: 'Leave this Business?',
  BUSINESS_LEAVE_CONFIRM_DESC:
    "Orders you placed under this Business stay attached to it; you won't see them after leaving.",
  BUSINESS_OWNER_CANNOT_REMOVE_SELF: 'Owners cannot remove themselves.',
  BUSINESS_MEMBER_REMOVED: 'Member removed.',
  BUSINESS_MEMBER_REMOVE_FAILED: 'Could not remove the member.',
  BUSINESS_MEMBER_REMOVE: 'Remove',
  BUSINESS_MEMBER_JOINED: 'Joined',
  BUSINESS_ROLE_OWNER: 'Owner',
  BUSINESS_ROLE_MEMBER: 'Member',
  BUSINESS_MEMBERS_EMPTY_TITLE: 'No members yet',
  BUSINESS_MEMBERS_EMPTY_DESC: 'Invite a teammate to share order management.',
  BUSINESS_INVITE_MEMBER: 'Invite member',
  BUSINESS_INVITE_HINT:
    "Send an invitation to a teammate's email. They have 7 days to accept.",
  BUSINESS_INVITATION_SEND: 'Send invitation',
  BUSINESS_INVITATION_SENDING: 'Sending…',
  BUSINESS_INVITATION_SENT: 'Invitation sent to {{email}}.',
  BUSINESS_INVITATION_SEND_FAILED: 'Could not send the invitation.',
  BUSINESS_INVITATION_REVOKE: 'Revoke',
  BUSINESS_INVITATION_REVOKED: 'Invitation revoked.',
  BUSINESS_INVITATION_REVOKE_FAILED: 'Could not revoke the invitation.',
  BUSINESS_INVITATION_EXPIRES: 'Expires',
  BUSINESS_INVITATIONS_EMPTY: 'No invitations yet.',
  BUSINESS_INVITATION_STATUS_PENDING: 'Pending',
  BUSINESS_INVITATION_STATUS_ACCEPTED: 'Accepted',
  BUSINESS_INVITATION_STATUS_EXPIRED: 'Expired',
  BUSINESS_INVITATION_STATUS_REVOKED: 'Revoked',
  BUSINESS_OWNER_ONLY_TITLE: 'Owner only',
  BUSINESS_OWNER_ONLY_DESC: 'Only the Business Owner can manage invitations.',
  PRODUCT_NOT_AVAILABLE_FOR_IDENTITY:
    'This product is not available for your account type.',
};

export default buyerEn;
